import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadCognitoForms,
  deleteCognitoForm,
} from '../../../../../state/modules/cognitoForms/actions';
import CognitoFormsList from '../components/CognitoFormsList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.cognitoForms.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['cognitoForms', x]),
                schema.cognitoForm,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              code: x.registration_code?.code ?? '',
              code_alias: x.registration_code?.code_alias ?? '',
              form_id: x?.form_id ?? '',
              form_key: x?.form_key ?? '',
              name: x?.name ?? '',
              profile_name: x.profile
                ? x.profile.first_name + ' ' + x.profile.last_name
                : '',
              ...x,
            };
          })
      : [],
    isLoading: state.cognitoForms.get('isLoading'),
    total: state.cognitoForms.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCognitoForms(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCognitoForm(id, cb));
    },
  };
};

const CognitoFormsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsList);

export default CognitoFormsListContainer;
